import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {PaymentModel} from '../../../model/payment.model';
import {HistoryModel} from '../../../shared/dto/history.model';
import {ApplicantRequestService} from '../../../service/applicant-request.service';

@Component({
  selector: 'app-request-history',
  templateUrl: './request-history.component.html',
  styleUrls: ['./request-history.component.scss']
})
export class RequestHistoryComponent implements OnInit {
  @Input() applicationId: number;
  public historyModel: HistoryModel[];

  displayedColumns: string[] = ['stage', 'desc','remark', 'user','date'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(private applicantRequestService: ApplicantRequestService) { }

  ngOnInit() {
    this.onSearch();
  }

  onSearch() {
    this.applicantRequestService.searchApplicantHistory(this.applicationId).subscribe(
      (result: any ) => {
        this.historyModel = result;
        this.dataSource = new MatTableDataSource(this.historyModel);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }
}
